export const actionConst = {
    OPEN_MODAL: 'ADD_ORGS_OPEN_MODAL',
    CLOSE_MODAL: 'ADD_ORGS_CLOSE_MODAL',
};
